module.exports = __webpack_public_path__ + "static/deathlock-9f6a5ff5001dbc4551b487aea8cb3b17.jpeg";